import { Image as UnpicImage, type ImageProps } from "@unpic/react";

export function Image(props: ImageProps & { style?: React.CSSProperties }) {
  const { style, className, width, height, aspectRatio, layout, ...imageProps } = props;

  // If className contains width/height classes, use flexible dimensions
  const hasWidthClass = className?.includes('w-') || className?.includes('width-');
  const hasHeightClass = className?.includes('h-') || className?.includes('height-');

  // Use provided dimensions, but fall back to flexible ones if CSS classes are present
  let finalWidth = width ?? 400;
  let finalHeight = height ?? 300;

  // If CSS classes are controlling dimensions, use more flexible base dimensions
  if (hasWidthClass && hasHeightClass) {
    // Both width and height are controlled by CSS, use aspect ratio friendly defaults
    finalWidth = width ?? 400;
    finalHeight = height ?? 300;
  } else if (hasWidthClass) {
    // Width is controlled by CSS, make height flexible
    finalWidth = width ?? 400;
    finalHeight = height ?? 300;
  } else if (hasHeightClass) {
    // Height is controlled by CSS, make width flexible
    finalWidth = width ?? 400;
    finalHeight = height ?? 300;
  }

  const imageElement = (
    <UnpicImage
      {...imageProps}
      className={className}
      layout={layout === "fullWidth" ? "constrained" : (layout ?? "constrained")}
      width={finalWidth}
      height={finalHeight}
    />
  );

  // Wrap in div with style if provided
  if (style) {
    return <div style={style}>{imageElement}</div>;
  }

  return imageElement;
}

export type { ImageProps };